module.exports = __webpack_public_path__ + "static/promotional_en-ef4752c79e26522f9e32.png";